import script from "./LockScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LockScreen.vue?vue&type=script&setup=true&lang=js"

import "./LockScreen.vue?vue&type=style&index=0&id=47b7085e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b7085e"]])

export default __exports__